export const AuthenticationScreens = {
    login: "LOGIN",
    OTP: "OTP",
    FTP: "FTP",
    CPWC: "CPWC",
    CP: "CP",
    RP: "RP",
    FP: "forgot-password",
    CR: "check-registration",
    AL: "AL" // Ageny Login
};
